import { gql } from "@apollo/client";
import useWrappedQuery from "../../common/data-fetching/useWrappedQuery.js";

const QUERY_SCOPE = "application";
const QUERY_NAME = "applicationByJobIdAndRecruiterIdRemainingCount";

export const QUERY = gql`
  query ${QUERY_SCOPE}_${QUERY_NAME}($jobId: ID!, $recruiterId: ID!) {
    ${QUERY_SCOPE} {
      _id
      ${QUERY_NAME}(jobId: $jobId, recruiterId: $recruiterId)
    }
  }
`;

export default function useQueryApplicationByJobIdAndRecruiterIdRemainingCount(
  jobId,
  recruiterId
) {
  const variables = { jobId, recruiterId };

  return useWrappedQuery(QUERY, QUERY_SCOPE, QUERY_NAME, {
    variables,
    // Get info from cache and ask the network at the same time, then update on response
    fetchPolicy: "cache-and-network",
  });
}
